import makeFormField from './makeFormField';
import DatePickerControl from '../formControls/DatePicker';
import SelectListControl from '../formControls/SelectList';
import CurrencyBoxControl from '../formControls/CurrencyBox';
import TextAreaControl from '../formControls/TextArea';
import TextBoxControl from '../formControls/TextBox';

export const DatePicker = makeFormField(DatePickerControl);
export const SelectList = makeFormField(SelectListControl);
export const CurrencyBox = makeFormField(CurrencyBoxControl);
export const TextArea = makeFormField(TextAreaControl);
export const TextBox = makeFormField(TextBoxControl);
